import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { BookPageComponent } from './book-page.component';
import { BookOrderComponent } from './book-order/book-order.component';
import { BookServiceComponent } from './book-service/book-service.component';
import { BookTileComponent } from './book-tile/book-tile.component';
import { BookService } from './book.service';
import { ParserModule } from '../../modules/parser/parser.module';
import { SpinnerModule, LoadingErrorModule, PipesModule, DfMonthPickerModule, ExceptionsModule, StoreProviderModule } from '@uxdf/direct-shared-lib';
import { EPowerComponent } from './e-power/e-power.component';
import { FormGroupModule, NavbarModule } from '@uxdf/p-components';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCompatModule } from '@uxdf/direct-shared-lib';
import { ReefI18nModule, ReefAppModule } from '@seco/core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DfSelectModule, DfMediaModule, DfAlertModule } from '@design-factory/design-factory';
import { CsvModule } from '@ctrl/ngx-csv';
import { DoughnutChartModule } from '../../directives/doughnutChart.module';

@NgModule({
  declarations: [BookPageComponent,
    BookOrderComponent,
    BookServiceComponent,
    BookTileComponent,
    EPowerComponent
  ],
  providers: [
    BookService
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ParserModule,
    SpinnerModule,
    CommonModule,
    FormGroupModule,
    NgSelectModule,
    FormsModule,
    LoadingErrorModule,
    ReactiveFormsModule,
    NgbCompatModule,
    PipesModule,
    ReefI18nModule,
    DfMonthPickerModule,
    NavbarModule,
    NgxPageScrollModule,
    StoreProviderModule,
    ExceptionsModule,
    DfSelectModule,
    CsvModule,
    DfMediaModule,
    ReefAppModule.forRoot(),
    DoughnutChartModule,
    DfAlertModule
  ],
  exports: [BookTileComponent],
})
export class BookModule {}